<template>
<div class="rounded-md bg-khks-red p-4 m-4 absolute bottom-0 right-0 w-auto">
  <div class="flex content-center ">
    <div class="flex-shrink-0 self-center">
      <!-- Heroicon name: x-circle -->
     <svg class="h-10 w-10 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
    </svg>
    </div>
    <div class="flex ml-3 self-center">
      <p class="text-lg font-medium text-white m-0 text-left">
         <span class="font-bold">Päivystys</span> löytyy E-rakennuksesta käyttämällä E5-ovea
      </p>
    </div>
  </div>
</div>
</template>

<script>

export default {
    name: "PaivystysAlert",
    props: {
    },
    data() {
        return {
        }  
    },
    methods: {
    },
    computed: {
  }  
    }
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.modal {
  height: 80%;
}
</style>
